import { render } from "./applicationdata.vue?vue&type=template&id=2b9113cc&scoped=true"
import script from "./applicationdata.vue?vue&type=script&lang=js"
export * from "./applicationdata.vue?vue&type=script&lang=js"

import "./applicationdata.vue?vue&type=style&index=0&id=2b9113cc&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9113cc"]])

export default __exports__